// network/userService.js
import { db } from "./firebaseConfig";
import {
    collection,
    doc,
    setDoc,
    serverTimestamp,
    getDocs,
    getDoc,
    updateDoc,
    deleteDoc,
} from "firebase/firestore";

const userCollectionRef = collection(db, "users");

class UserService {
    // ✅ Create or overwrite document with UID as doc ID
    addUser = async (user) => {
        const ref = doc(userCollectionRef, user.uid); // doc ID = UID
        await setDoc(ref, {
            ...user,
            createdAt: serverTimestamp(),
        });
        return ref;
    };

    getAllUsers = async () => {
        return await getDocs(userCollectionRef);
    };

    getUser = async (id) => {
        const ref = doc(db, "users", id);
        return await getDoc(ref);
    };

    updateUser = async (id, data) => {
        const ref = doc(db, "users", id);
        return await updateDoc(ref, data);
    };

    deleteUser = async (id) => {
        const ref = doc(db, "users", id);
        return await deleteDoc(ref);
    };
}
const userService = new UserService();
export default userService;


// // network/userService.js
// import { db } from "./firebaseConfig";
// import { collection, addDoc, serverTimestamp, getDocs, getDoc, doc, updateDoc, deleteDoc } from "firebase/firestore";

// const userCollectionRef = collection(db, "users");

// class UserService {
//     addUser = async (user) => {
//         return await addDoc(userCollectionRef, {
//             ...user,
//             createdAt: serverTimestamp(),
//         });
//     };

//     getAllUsers = async () => {
//         return await getDocs(userCollectionRef);
//     };

//     getUser = async (id) => {
//         const ref = doc(db, "users", id);
//         return await getDoc(ref);
//     };

//     updateUser = async (id, data) => {
//         const ref = doc(db, "users", id);
//         return await updateDoc(ref, data);
//     };

//     deleteUser = async (id) => {
//         const ref = doc(db, "users", id);
//         return await deleteDoc(ref);
//     };
// }

// export default new UserService();
